/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   3/14/22
 */

import React from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, TextField} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import {State} from "../state/store";
import {set} from "../state/reducers/calendar";
import {useClient} from "urql";
import {
	CreateSavedCalendarMutation,
	CreateSavedCalendarResponse,
	CreateSavedCalendarVars, SavedCalendarInput
} from "../graphql/mutations/calendars";
import {useNavigate} from "react-router-dom";
import { toast } from "react-toastify";

export interface SettingsSaveAsDialogProps {
	open: boolean
	onClose: () => void
}

export default function SettingsSaveAsDialog({ open, onClose }: SettingsSaveAsDialogProps) {

	const client = useClient();
	const dispatch = useDispatch();
	const calendar = useSelector((s:State) => s.calendar);
	const filter = useSelector((s:State) => s.employeesFilter);
	const settings = useSelector((s:State) => s.settings);
	const navigate = useNavigate();

	const [title, setTitle] = React.useState(calendar.title);

	React.useEffect(() => {
		setTitle(calendar.title);
	}, [calendar.title]);

	return (
		<Dialog
			open={open}
			onClose={onClose}
			fullWidth
			maxWidth={"xs"}
		>
			<DialogTitle>Save As</DialogTitle>
			<DialogContent>
				<FormControl fullWidth>
					<TextField
						variant={"standard"}
						label={"Title"}
						value={title}
						onChange={(event) => {
							setTitle(event.target.value as string);
						}}
					/>
				</FormControl>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Cancel</Button>
				<Button
					disabled={title.length === 0 || title.length > 60}
					onClick={() => {
						const data: SavedCalendarInput = {
							title,
							isPublic: true,
							config: {
								employeesFilter: filter,
								settings
							}
						};
						client.mutation<CreateSavedCalendarResponse, CreateSavedCalendarVars>(
							CreateSavedCalendarMutation, {data}).toPromise().then(r => {
								if (r.data?.createSavedCalendar) {
									dispatch(set({
										id: r.data.createSavedCalendar.id,
										title: r.data.createSavedCalendar.title,
									}));
									navigate("/calendar/" + r.data.createSavedCalendar.id);
									toast.success(`Calendar "${title}" (${r.data.createSavedCalendar.id}) has been saved successfully`);
								}
						});
						onClose();
					}}
					variant={"contained"}
					color={"primary"}
				>
					Save
				</Button>
			</DialogActions>
		</Dialog>
	);

}